import React, {Component} from 'react'
import {equals} from 'ramda'
import Analytics from '..'

const withAnalyticsOnCollapse = WrappedComponent =>
  class extends Component {
    static displayName = `${WrappedComponent.displayName}withAnalyticsOnCollapse`

    constructor(props) {
      super(props)

      this.analytics = new Analytics(props.analytics)
    }

    componentDidUpdate(prevProps) {
      if (
        prevProps.analytics &&
        !equals(prevProps.analytics.contexts, this.props.analytics.contexts)
      ) {
        this.analytics = new Analytics(this.props.analytics)
      }
    }

    onCollapse = (text, action) => {
	    const { onCollapseHandle } = this.props

      this.analytics.event({text, action})

	    onCollapseHandle && onCollapseHandle()
    }

    render() {
      return <WrappedComponent onCollapse={this.onCollapse} {...this.props}/>
    }
  }

export default withAnalyticsOnCollapse
